// ABOUTME: Configuration for external channels tab in relation portal settings
// ABOUTME: Defines tab structure and icons for external channels management page

import IntegrationInstructionsIcon from '@mui/icons-material/IntegrationInstructions';

export const relationSettingsExternalChannelsConfig = {
    all: {
        title: 'external_channels',
        subtitle: 'external_channels',
        icon: <IntegrationInstructionsIcon />,
        isSingleDataGrid: true,
    },
};
